//import ReactDOM from 'react-dom/client';
//import Login from '../../Login';
//import '../../assets/css/bootstrap.min.css';
import '../../assets/css/style.css';
import '../../assets/css/all.css';
import '../../assets/css/AdminDashboard.css';
import Nav from '../../Nav.js';
//import avtlogo from "../../img/avt.svg";
import avtroute from "../../img/route.png";
import avtcarpark from "../../img/car-parking.png";
import avtcar from "../../img/car.png";
import avtnosignal from "../../img/no-signal.png";
import avtbarchart from "../../img/bar-chart.png";
//import avtprofile from "../../img/avatar.jpg";
import { Helmet } from "react-helmet";
//import CanvasJS from "../../assets/js/canvasjs.min.js";
//import { getUser, removeUserSession } from '../../utils/common';

{/*
const handleLogout = () => {
  removeUserSession();
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<Login/>);    
}
*/}
const CDashboard = () => {
   
    return (
        <div className="page-panel">
	
<Helmet>
     
        <script type="text/javascript">
	                window.loaddashboard();                  
        </script>
</Helmet>

	<div className="page-body">
  
  
    
      <div className="sidebar border border-right bg-body-tertiary">
      <Nav/>
       
      </div>
      <main>
        
          <div className="top-bar clearfix">
            <div className="row">
              <div className="col-xs-12">
                <h2> Dashboard</h2>
              </div>
            </div>
          </div>
          <div className="content">
        <div className="row">
          <div className="col-lg-5">
            <div className="row">
              <div className="col-12 col-sm-6">
                <div className="card form-group">
                  <div className="card-body">
                    <h6 className="text-center">Vehicle Status</h6>
                    <div id="vehicleStatus"></div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <div className="card form-group">
                  <div className="card-body dash-block d-flex align-items-center flex-column"> <img src={avtcar} alt="Vehicle"/> <span className="num">3</span>
                    <h6>All Vehicle</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="row">
              <div className="col-12 col-sm-6 col-md-4">
                <div className="card form-group">
                  <div className="card-body dash-block d-flex align-items-center flex-column"> <img src={avtroute} alt="Moving"/> <span className="num text-success">0</span>
                    <h6 className="text-success">Moving</h6>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4">
                <div className="card form-group">
                  <div className="card-body dash-block d-flex align-items-center flex-column"> <img src={avtcarpark} alt="Parking"/> <span className="num text-warning">3</span>
                    <h6 className="text-warning">Parked</h6>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4">
                <div className="card form-group">
                  <div className="card-body dash-block d-flex align-items-center flex-column"> <img src={avtnosignal} alt="Not Updating"/> <span className="num text-danger">0</span>
                    <h6 className="text-danger">Not updating</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="card form-group">
              <div className="card-body p-0">
                <div className="row g-0 statusBlock">
                  <div className="col-6 d-flex align-items-center flex-column justify-content-center p-4 border-bottom">
                    <h5 className="text-success">0</h5>
                    <p className="m-0"><small><i className="fa-solid fa-check text-success"></i> </small> Online</p>
                  </div>
                  <div className="col-6 d-flex align-items-center flex-column justify-content-center p-4 border-bottom border-start">
                    <h5 className="text-muted">3</h5>
                    <p className="m-0"><small><i className="fa-light fa-xmark text-danger"></i> </small> Offline</p>
                  </div>
                  <div className="col-6 d-flex align-items-center flex-column justify-content-center p-4">
                    <h5 className="text-info">3</h5>
                    <p className="m-0"><small><i className="fa-solid fa-check text-info"></i> </small> Activated</p>
                  </div>
                  <div className="col-6 d-flex align-items-center flex-column justify-content-center p-4 border-start">
                    <h5 className="text-danger">0</h5>
                    <p className="m-0"><small><i className="fa-light fa-xmark text-danger"></i> </small> Inactive</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="row">
              <div className="col-12 col-md-8">
                <div className="card form-group">
                  <div className="card-body py-3">
                    <div id="lineChart"></div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="card form-group">
                  <div className="card-body dash-block d-flex align-items-center flex-column"> <img src={avtbarchart} alt="Not Updating"/>
                    <h6>Vehicle History</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
</div>
      </main>
    
  
</div>
	</div>
    );
  
};




export default CDashboard;